import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { styles, theme } from 'app/theme'
import { useVocabularyData } from 'app/utils/vocabulary'
import { rgba } from 'emotion-rgba'
import { compact, uniqBy } from 'lodash'
import React, { memo, useContext } from 'react'

import { CompanyData } from './CompanyData'
import { FooterContext } from './index'
import { PolicyMenuItem } from './PolicyMenuItem'

export const Bottom = memo(function Bottom() {
  const { languageCode, policyMenu } = useContext(FooterContext) as any

  return (
    <Container row space="between" wrap>
      <Wrapper dial={4} row wrap>
        <CompanyData />

        {policyMenu
          ? uniqBy(policyMenu, 'title').map((item: any, index) => (
              <PolicyMenuItem key={index} {...item} />
            ))
          : null}
      </Wrapper>

      <Anchor
        aria-label="Link to Credits"
        href="https://www.qnt.it"
        rel="noopenet"
        tabIndex={0}
        target="_blank"
      >
        {useVocabularyData('credits', languageCode)}
      </Anchor>
    </Container>
  )
})

const Container = styled(FlexBox)`
  border-top: 0.0625rem solid ${rgba(theme.colors.variants.neutralLight1, 0.2)};
  padding: 2rem 5vw;

  @media (max-width: 1199px) {
    display: block;
    padding: 2rem 2rem 8.75rem;
  }
`

const Wrapper = styled(FlexBox)`
  @media (max-width: 1199px) {
  }
`

const Anchor = styled.a`
  ${styles.description}

  color: ${({ theme }) => theme.colors.variants.neutralLight1};
  font-size: 0.875rem;
  line-height: 1.25rem;
  position: relative;
  &:after {
    content: '';
    width: 100%;
    height: 0.0625rem;
    background: ${({ theme }) => theme.colors.variants.neutralLight1};
    pointer-events: none;
    position: absolute;
    bottom: 0;
    left: 0;
    transform: scaleX(0);
    transform-origin: right;
    transition: transform 0.8s cubic-bezier(0.24, 0.43, 0.15, 0.97);
  }
  &:hover {
    &:after {
      transform: scaleX(1);
      transform-origin: left;
    }
  }

  @media (max-width: 1199px) {
    display: inline-block;
    margin-top: 1.5rem;
  }
`
